module.exports = __webpack_public_path__ + "img/bingo_ball-59.c43314b1.png";